import ContentArticle from "@/components/content/ContentArticle";
import {
  contentPaths,
  contentProps,
  type ContentPageProps,
} from "@/utils/contentProps";

export default function ComparePage(props: ContentPageProps) {
  return <ContentArticle {...props} />;
}

export const getStaticPaths = contentPaths("compare");
export const getStaticProps = contentProps("compare");
